import {HttpClient, HttpErrorResponse,HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { ProximaAsignacion,ProximaAsignacionInput } from "../entidades/entidades";
import Utils from "../shared/utilerias/utils";

@Injectable({
  providedIn: "root"
})
export class ProximaAsignacionService {
  private actionUrl: string;
  private actionUrlOperaciones: string;
  private headers: HttpHeaders;

  constructor(private http: HttpClient) {
    this.actionUrl = Utils.getBaseUrlApiWeb() + "/ProximaAsignacion/";
    this.actionUrlOperaciones = Utils.getBaseUrlApiWeb() + "/ProximaAsignacion/Operaciones/";
    this.headers = new HttpHeaders();
    this.headers = this.headers.set("Content-Type", "application/json");
    this.headers = this.headers.set("Accept", "application/json");
  }

  postOperaciones(proximaAsignacionInput: ProximaAsignacionInput): Observable<ProximaAsignacion> {
    return this.http.post<ProximaAsignacion>(this.actionUrlOperaciones, proximaAsignacionInput, {headers: this.headers}).pipe(catchError(this.handleError));
  }
  
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // Error en el cliente
      console.error('Error del cliente:', error.error.message);
    } else {
      // Error en el backend
      console.error(`Backend retornó el código ${error.status}, ` +
                    `mensaje: ${error.error.message}`);
    }
    // Devuelves un observable con el error
    return throwError(() => new Error(error.error.message || 'Algo salió mal'));
  }
}